import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { getPresets } from '../../../../../../../store/actions/posPresets';
import Main from './Main';
import CategoryView from './CategoryView';
import useReduxReducer from '../../../../../../../hooks/useReduxReducer';
import presets from '../../../../../../../store/reducers/pos/presets';

const PresetsWrapper = styled.div`
  flex: 3;
  margin: 0px 10px;
  display: flex;
  flex-direction: column;
`;

const Presets = ({ transactionId }) => {
  const dispatch = useDispatch();
  useReduxReducer({presets});

  const [activeCategory, setActiveCategory] = useState(null);

  useEffect(() => {
    dispatch(getPresets());
  }, [dispatch]);

  return (
    <PresetsWrapper>
      <Main setActiveCategory={setActiveCategory} activeCategory={activeCategory} />
      {activeCategory && <CategoryView category={activeCategory} closeCategory={() => setActiveCategory(null)} transactionId={transactionId} />}
    </PresetsWrapper>
  );
};

export default Presets;
